import { customerApi } from "../../utils/apiConfig";
//  Get

export const getMakinaData = (makinaAdi = "all", page = 1, limit = 100) => {
  return customerApi.get(`/getBoruUretimAnaliz/${makinaAdi}/${page}/${limit}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getBoruUretimAnalizDemo = (
  makinaAdi = "all",
  page = 1,
  limit = 100
) => {
  return customerApi.get(
    `/getBoruUretimAnalizDemo/${makinaAdi}/${page}/${limit}`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const getBoruUretimKalinlikAnalizDemo = (
  makinaAdi = "all",
  page = 1,
  limit = 100,
  filters = {}
) => {
  return customerApi.get(
    `/getBoruUretimKalinlikAnalizDemo/${makinaAdi}/${page}/${limit}`,
    {
      params: filters,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};

export const insertMakinaExcelPaste = (data = {}) => {
  return customerApi.post("/boru-profil-uretim/excel-paste", data, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const compareMakinaExcelDebug = (data = {}) => {
  return customerApi.post("/boru-profil-uretim/excel-debug", data, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getSureAnaliz = (year) => {
  return customerApi.get(`/getUretimSureAnaliz/${year}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getAylikAnaliz = (year) => {
  return customerApi.get(`/getAylikAnaliz/${year}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const gunlukToplamAnaliz = (year, month) => {
  return customerApi.get(`/gunlukToplamAnaliz/${year}/${month}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const sureAnaliz = (year, month) => {
  return customerApi.get(`/sureAnaliz/${year}/${month}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
